import cx from 'clsx';
import React, { CSSProperties } from 'react';

import { useIntersectionObserver } from '@/hooks/useIntersectionObserver';

import { isHeadless } from './utils';

export interface IntersectionObserverWrapperPropTypes {
  children: React.ReactNode;
  disabled?: boolean;
  className?: string;
  style?: CSSProperties;
  dataTestId?: string;
  loadingClassName?: string;
}

const IntersectionObserverWrapper: React.FC<IntersectionObserverWrapperPropTypes> = ({
  children,
  className,
  style,
  dataTestId,
  loadingClassName,
  disabled,
}) => {
  const { ref, intersected } = useIntersectionObserver(isHeadless);
  return (
    <div
      data-testid={dataTestId || ''}
      ref={ref}
      className={cx(className, !disabled && !intersected && loadingClassName)}
      style={style || {}}
    >
      {disabled || intersected ? children : null}
    </div>
  );
};

export default IntersectionObserverWrapper;
